/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  deleteInboxIcon(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/icon`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  getClassification(data) {
    return axios.get(`${this.baseUrl()}/contact_classifications`)
  }
  setClassification(data) {
    return axios.post(`${this.baseUrl()}/contact_classifications`,data)
  }
  deleteClassification(id) {
    return axios.delete(`${this.baseUrl()}/contact_classifications/${id}`)
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }
}

export default new Inboxes();
